import setModalVideo from "../../../frontend/js/video-modal";
import VideoPlayTrigger from "tf-public/js/video-play-trigger.js";

class CampaignHeroVideoPlayer extends VideoPlayTrigger{
    constructor() {
        super({ triggerSelector: '.content-block__play', imageSelector: '.content-block__image', onClose: () => window.headroom.elem.style.zIndex = 0, onPlay: () => window.headroom.elem.style.zIndex = 3 });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new CampaignHeroVideoPlayer();
});
